import { useCallback } from 'react';

import { type FormInputChangeProps } from './types';

export const useFormInputChange = <TValue>(
  props: FormInputChangeProps<TValue>
) => {
  const { name, onChange } = props;

  return useCallback(
    (value: TValue) =>
      (onChange as (value: TValue, name?: string) => void)(value, name),
    [name, onChange]
  );
};
